import { clearFormIdempotencyKey } from '@/platform/storage/formIdempotency'
import {
  FooterActions as Actions,
  type FooterActionsProps,
} from '@/shared/ui/FooterActions'
import { useRouter } from 'next/router'
import { useOuvidoriaState } from './state'

export function FooterActions(
  props: Omit<FooterActionsProps, 'onCancelConfirm'>,
) {
  const { resetState } = useOuvidoriaState()
  const router = useRouter()
  function cancel() {
    resetState()
    clearFormIdempotencyKey('ouvidoria')
    void router.push('https://seja.flashapp.com.br/fale-com-a-ouvidoria')
  }
  return <Actions {...props} onCancelConfirm={cancel} />
}
